
import React from 'react';

interface OptionMenuProps {
  menuItems: React.ReactNode;
}

const OptionMenu: React.FC<OptionMenuProps> = ({ menuItems }) => {
  return (
    <>
      {menuItems}
    </>
  );
};

export default OptionMenu;
